import stations from "./stations"

const _export = {
    stations
}

export default _export